import React, { Component } from 'react';
import { Avatar } from 'antd';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { addAlertToAlertsList } from '../../../actionCreators/globalAlerts';

import { dateDifferenceShorted } from '../../../utils/helpers';
import ImageApi from '../../../api/image';
import UserPlaceholder from '../../../assets/images/user_placeholder.svg';
import { connect } from 'react-redux';
import { deleteCommunityRequest } from '../../../actionCreators/communitiesActions';

import CreateFeedItemCommunity from '../../Feed/CreateFeedItem/CreateFeedItemCommunity';

import ErrorModal from '../../ErrorModal';

import {
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { logFirebaseEvent } from '../../../firebase/analytics';
import {sendFeedbackRequest} from "../../../actionCreators/feedActions";
import SendFeedback from "../../SendFeedback";

class communityDetailsHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageUrl: '',
      menuOpen: false,
      deleteModalOpen: false,
      editModalOpen: false,
      isErrorModalOpen: false,
      errorModalTitle: '',
      errorModalMessage: '',
      selectedReportingReason: null,
      reportPostModalOpen: false,
      reportPostDescription: '',
      showErrors: false,
      feedbackModalOpen: false,
    };
  }

  componentDidMount() {
    if (!this.props.author.image || !this.props.author.image.thumbnailUrl) return;

    ImageApi.getImage(this.props.author.image.thumbnailUrl).then((imageUrl) => {
      this.setState({ imageUrl });
    });
  }

  toggleMenu = () => {
    this.setState({ menuOpen: !this.state.menuOpen });
  };

  toggleDeleteConfirmModal = () => {
    this.setState({ deleteModalOpen: !this.state.deleteModalOpen });
  };

  toggleEditModal = () => {
    this.setState({ editModalOpen: !this.state.editModalOpen });
  };

  toggleFeedbackModal = () => {
    this.setState({
      feedbackModalOpen: !this.state.feedbackModalOpen
    })
  }

  resetErrorModal = () => {
    this.setState({
      isErrorModalOpen: false,
      errorModalTitle: '',
      errorModalMessage: '',
    });
  };

  deleteCommunity = async () => {
    logFirebaseEvent({
      event: 'delete_community',
    });
    await this.props.deleteCommunity({ communityId: this.props.communityId });
    this.setState({ deleteModalOpen: !this.state.deleteModalOpen });
    this.props.goBack();
  };

  checkFields = (type, data) => {
    if (type === 'Community') {
      if (
        data.title.error ||
        data.description.error ||
        data.location.error ||
        data.details.error ||
        data.phone.error ||
        (data.email_address.value && data.email_address.error)
      ) {
        return false;
      }
    }

    return true;
  };

  onSubmit = async (type, data) => {
    logFirebaseEvent({
      event: 'community',
      action: 'update',
    });

    if (
      data.title.error ||
      data.description.error ||
      data.location.error ||
      data.details.error ||
      data.phone.error ||
      (data.email_address.value && data.email_address.error)
    ) {
      return this.setState({
        ...this.state,
        showErrors: true,
      });
    }

    data.title = data.title.value;
    data.description = data.description.value;
    data.location = data.location.value;
    data.details = data.details.value;

    if (data.phone.value) {
      data.phone = data.phone.value;
    } else {
      delete data.phone;
    }

    if (data.email_address.value) {
      data.email_address = data.email_address.value;
    } else {
      delete data.email_address;
    }

    if (!data.image_id) {
      delete data.image_id;
    }

    this.props.updateCommunity({
      communityId: this.props.communityId,
      data: data,
      cb: () => this.toggleEditModal(),
    });
  };

  render() {
    const { author, createdAt, link, currentUser } = this.props;

    return (
      <div className={`community-item-header d-flex align-items-center`}>
        <Modal isOpen={this.state.deleteModalOpen} centered>
          <ModalHeader>
            <div>Delete Community</div>
          </ModalHeader>
          <ModalBody>
            <div>Are you sure you want to delete this community? This action cannot be undone.</div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleDeleteConfirmModal}>
              Cancel
            </Button>
            <div style={{ flex: 1 }} />
            <Button color="primary" onClick={() => this.deleteCommunity()}>
              Delete
            </Button>
          </ModalFooter>
        </Modal>

        <Modal size="lg" style={{ maxWidth: '690px' }} isOpen={this.state.editModalOpen} centered>
          <ModalHeader toggle={this.toggleEditModal}>
            <div>Edit Community</div>
          </ModalHeader>
          <ModalBody>
            <div className="create-feed">
              <CreateFeedItemCommunity
                onSubmit={this.onSubmit}
                showErrors={this.state.showErrors}
                checkFields={this.checkFields}
                communityId={this.props.communityId}
                addAlertToAlerts={this.props.addAlertToAlerts}
              />
            </div>
          </ModalBody>
        </Modal>

        <SendFeedback isOpen={this.state.feedbackModalOpen} item={{postable_id: this.props.communityId, postable_type: 'community'}} sendFeedback={this.props.sendFeedback} toggleOpen={this.toggleFeedbackModal} />

        <ErrorModal
          isOpen={this.state.isErrorModalOpen}
          title={this.state.errorModalTitle}
          message={this.state.errorModalMessage}
          onClose={this.resetErrorModal}
        />

        <Avatar
          shape="square"
          className="community-item-header-image"
          src={this.state.imageUrl || UserPlaceholder}
          icon="user"
          size={42}
        />

        <div className="community-item-header-content d-flex flex-column flex-fill">
          <div className="d-flex justify-content-between">
            <p className="community-item-header-text">
              <Link className="community-item-header-text" to={`/users/${author.id}`}>
                {author.first_name} {author.last_name}
              </Link>
            </p>

            <div>
              <Dropdown isOpen={this.state.menuOpen} direction="left" toggle={this.toggleMenu}>
                <DropdownToggle
                  tag="span"
                  data-toggle="dropdown"
                  aria-expanded={this.state.menuOpen}
                >
                  <FontAwesomeIcon
                    className="community-item-header-collapse"
                    icon={['fas', 'chevron-down']}
                  />
                </DropdownToggle>
                <DropdownMenu>
                  {currentUser.userData.is_admin && currentUser.userData.id === author.id ? (
                      <DropdownItem onClick={this.toggleEditModal}>Edit Community</DropdownItem>
                  ) : null}
                  {currentUser.userData.is_admin && currentUser.userData.id === author.id ? (
                  <DropdownItem onClick={this.toggleDeleteConfirmModal}>
                    Delete Community
                  </DropdownItem>
                  ) : null}
                  <DropdownItem onClick={this.toggleFeedbackModal}>Send Feedback</DropdownItem>
                  <DropdownItem onClick={this.toggleCancelConfirmModal}>Cancel</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>

          <Link to={link} className="community-item-header-time">
            {dateDifferenceShorted(createdAt)}
          </Link>
        </div>
      </div>
    );
  }
}

export default connect(
  (state, props) => ({
    currentUser: state.currentUser,
  }),
  (dispatch) => ({
    deleteCommunity: (payload) => dispatch(deleteCommunityRequest(payload)),
    sendFeedback: (payload) => dispatch(sendFeedbackRequest(payload)),
    addAlertToAlerts: (payload) => dispatch(addAlertToAlertsList(payload)),
  }),
)(communityDetailsHeader);
